if (!customElements.get('price-range')) {
  class PriceRange extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.minNumberInput = this.querySelector('#price-range-number-min');
      this.maxNumberInput = this.querySelector('#price-range-number-max');
      this.minSliderInput = this.querySelector('#price-range-slider-min');
      this.maxSliderInput = this.querySelector('#price-range-slider-max');

      if (!this.minNumberInput || !this.maxNumberInput) return;

      this.minValue = Number(this.minNumberInput.min);
      this.maxValue = Number(this.maxNumberInput.max);
      this.timeout = null;
      this.addEventListener('input', this.handleInput.bind(this));
    }

    handleInput(evt) {
      if (evt.detail !== undefined) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.updateSliderInputs(evt);
          this.updateNumberInputs();
        }, 500);
      } else {
        this.updateSliderInputs(evt);
        this.updateNumberInputs();
      }
    }

    updateNumberInputs() {
      if (!this.minSliderInput || !this.maxSliderInput) return;

      this.minNumberInput.value = this.minSliderInput.value !== this.minNumberInput.min
        ? this.minSliderInput.value : null;
      this.maxNumberInput.value = this.maxSliderInput.value !== this.maxNumberInput.max
        ? this.maxSliderInput.value : null;
    }

    updateSliderInputs(evt) {
      if (!this.minSliderInput || !this.maxSliderInput) return;

      const minValue = parseInt(this.minNumberInput.value, 10);
      const maxValue = parseInt(this.maxNumberInput.value, 10);

      if (minValue > maxValue - 10) {
        if (evt.target === this.minNumberInput) {
          this.maxSliderInput.value = minValue + 10;
          if (maxValue === this.maxValue) {
            this.minSliderInput.value = this.maxValue - 10;
          }
        } else {
          this.minSliderInput.value = maxValue - 10;
        }
      }

      if (maxValue < minValue + 10) {
        if (evt.target === this.maxNumberInput) {
          this.minSliderInput.value = maxValue - 10;
          if (minValue === this.minValue) {
            this.maxSliderInput.value = 10;
          }
        } else {
          this.maxSliderInput.value = minValue + 10;
        }
      }

      if (evt.target === this.minNumberInput) {
        this.minSliderInput.value = minValue || Number(this.minNumberInput.min);
      }
      if (evt.target === this.maxNumberInput) {
        this.maxSliderInput.value = maxValue || Number(this.maxNumberInput.max);
      }
    }
  }

  customElements.define('price-range', PriceRange);
}
